
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moje-konto/blad-platnosci",
      function () {
        return require("private-next-pages/moje-konto/blad-platnosci.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moje-konto/blad-platnosci"])
      });
    }
  